import { forwardRef, memo } from "react"

import { CheckbokItem } from "./CheckbokItem"
import { CheckListProps } from "./types"

export const CheckList = memo(forwardRef<HTMLDivElement, CheckListProps>(({ items, selectedItems, onChange }: CheckListProps, ref) => {
    return (
        <div ref={ref} className="flex flex-col gap-2 p-2 rounded-md bg base-shadow bg-base-popover">
            {items.map(item => <CheckbokItem key={item.value} item={item} selectedItems={selectedItems} onChange={onChange} />)}
        </div>
    )
}))